






















































































/* eslint-disable */
import {
  Component, Vue, Watch,
} from 'vue-property-decorator';
import AddIcon from 'mdi-vue/Plus';
import dayjs from 'dayjs';

import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import Pagination from '@/components/Pagination.vue';
import ActionPopup from '@/components/ActionPopup.vue';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';
import Checkbox from '@/components/Checkbox.vue';

import api from '@/libs/api';
import numberFormat from '@/libs/numberFormat';
import {
  Service,
} from '@/libs/api.interfaces';
import { AxiosError } from 'axios';

interface ReportParams {
  merchant: { merchant_code: string; merchant_name: string } | null;
  month: LabelValue | null;
  year: LabelValue | null;
  status: LabelValue | null;
  service: any | null;
  brand: any | null;
}

@Component({
  components: {
    ScrollbarWrapper,
    Button,
    AddIcon,
    Table,
    TableBody,
    Row,
    Header,
    Cell,
    Loader,
    StatusIndicator,
    Pagination,
    ActionPopup,
    Checkbox,
  },
  methods: {
    numberFormat,
  },
})
export default class InvoiceTable extends Vue {
  // pagination
  page = 1;
  totalPage = 1;
  from = 0;
  to = 0;
  totalItem = 0;

  loading = true;
  listDataInvoice: any[] = [];

  selected: { [rowId: string]: any } = {};

  numberFormat!: typeof numberFormat;

  statuses = [
    '',
    'CLAIM',
    'PENDING',
    'GENERATED',
  ];

  @Watch('page')
  onPageChange() {
    this.$router.push({
      query: { ...this.$route.query, page: this.page.toString() },
    });
  }

  async getInvoice(params: ReportParams, page = 1, isExport: boolean) {
    try {

      const merchant_code = params.merchant ? (params.merchant.merchant_code || undefined) : undefined;
      const year = params.year && params.year.value !== '0' ? params.year.value : 0;
      const month = params.month && params.month.value !== '0' ? params.month.value : 0;
      const status = params.status && params.status.value !== '0' ? params.status.value : undefined;
      const service = params.service && params.service.service !== 'All'
        ? params.service.service : undefined;
      const brand_name = params.brand && params.brand.brand_name !== 'All'
        ? params.brand.brand_name : undefined;
      const periode = year === 0 && month === 0 ? undefined : `${year}-${month}`;

      if (isExport) {
        await api.get('recon/invoice/export', {
          params: {
            merchant_code,
            periode,
            status,
            service,
            brand_name,
          },
          responseType: "arraybuffer"
        }).then((response) => {
          const url = window.URL.createObjectURL(
            new Blob([response.data])
          );
          let link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Invoice_${periode}.xlsx`);
          document.body.appendChild(link);
          link.click();
        })
      } else {
        this.loading = true;

        const { data } = await api.get('/recon/invoice', {
          params: {
            page,
            // eslint-disable-next-line @typescript-eslint/camelcase
            merchant_code,
            periode,
            status,
            service,
            brand_name,
          },
        });

        if (data.data) {
          this.page = page;
          this.listDataInvoice = data.data.data;
          this.totalPage = Math.ceil(data.data.total / data.data.per_page);
          this.from = data.data.from;
          this.to = data.data.to;
          this.totalItem = data.data.total;
          this.checkAll(true);
        }
        this.loading = false;
      }

      return null;
    } catch (err) {
      console.error(err);
      return err as AxiosError;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  dateFormat(time: string) {
    const formatted = dayjs(time).format('MMMM D, YYYY HH:mm:ss');
    if (formatted === 'Invalid Date') {
      return '-';
    }

    return formatted;
  }

  // eslint-disable-next-line class-methods-use-this
  periodFormat(time: string) {
    const formatted = dayjs(time, 'MM-YYYY').format('MMMM YYYY');
    if (formatted === 'Invalid Date') {
      return '-';
    }

    return formatted;
  }

  selectRow(itemData: any) {
    if (this.isSelected(itemData.id)) {
      this.$delete(this.selected, itemData.id);
    } else {
      this.$set(this.selected, itemData.id, itemData);
    }

    this.$emit('select-change', Object.keys(this.selected).length);
  }

  isSelected(rowId: any) {
    return this.selected[rowId] !== undefined;
  }

  get isAllChecked() {
    return this.listDataInvoice.every((e) => this.selected[e.id] !== undefined);
    // return true;
  }

  checkAll(checked: boolean) {
    if (checked) {
      this.listDataInvoice.forEach((e) => {
        this.$set(this.selected, e.id, e);
      });
    } else {
      this.listDataInvoice.forEach((e) => {
        this.$delete(this.selected, e.id);
      });
    }

    this.$emit('select-change', Object.keys(this.selected).length);
  }
}
